
export default class Dependencies {

	static BASE_PATH = `${window.config.themeDirectory}/node_modules/`;

	static libraries = {
		googleMaps:			`https://maps.googleapis.com/maps/api/js?key=${window.config.googleMapsApiKey}`,
		luminous:			Dependencies.BASE_PATH + 'luminous-lightbox/dist/luminous.min.js',
		mailchimp:			'https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js',
		pikaday: 			`${window.config.themeDirectory}/dist/vendor/pikaday.js`,
		recaptcha:			'https://www.google.com/recaptcha/api.js',
		splide:				Dependencies.BASE_PATH + '@splidejs/splide/dist/js/splide.min.js',
		snazzyInfoWindow: 	Dependencies.BASE_PATH + 'snazzy-info-window/dist/snazzy-info-window.min.js',
		vimeo:				Dependencies.BASE_PATH + '@vimeo/player/dist/player.min.js',
		youtube:			'https://www.youtube.com/iframe_api',
		revinate:			'https://contact-api.inguest.com/bundles/revinatecontactapi/js/revinate-form.js?v=1',
		glightbox: 			Dependencies.BASE_PATH + 'glightbox/dist/js/glightbox.min.js',
	};

	/**
	 * Stylesheets that belong to a library. They are loaded together with it, so pages that
	 * do not use the library do not download them. Keyed by the library's script path.
	 * @type {Object<string, string>}
	 */
	static styles = {
		[Dependencies.libraries.glightbox]: `${window.config.themeDirectory}/dist/vendor/glightbox.min.css`,
		[Dependencies.libraries.snazzyInfoWindow]: `${window.config.themeDirectory}/dist/vendor/snazzy-info-window.css`,
	};

}
